import { getOrdersOrderIdPayments } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { useQuery } from "@tanstack/react-query";

export const getOrderPaymentListQueryKey = (orderId: number) => [
	"ORDER_PAYMENT_LIST",
	orderId,
];

export function useOrderPaymentListQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderPaymentListQueryKey(orderId),
		queryFn: processResponse(() => getOrdersOrderIdPayments(orderId)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled:
			!!orderId && hasPermission(UserPermissions.OrderPaymentModule.read),
	});
}
